import type { FaireProductEntity } from "../../entity_types/product";

export const p_56b2jrxggw: FaireProductEntity = {
  token: "p_56b2jrxggw",
  type: "product",
  name: "Mahj Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/dcb68712993d3abcb8affb599e6f8d8dfb3fe1e9fef17d5e6f7c3c358dacd642.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b8e829ce5df8101620b477ca541fca51e333e3467fb37a2aa6db76e7c744ef7c.jpeg",
    "https://cdn.faire.com/fastly/babe53101bf64f1701c38b9722de7e13138c46e64a2d630c148898c42f79a06a.jpeg",
    "https://cdn.faire.com/fastly/3939c9867e98def82bdff61083c489236c52c57662dbda2375eed30b3a29605d.jpeg",
    "https://cdn.faire.com/fastly/e3bf9f81d62beb0429ef4dda8883e0666749417b245d6af956784acf3814893d.jpeg"
  ],
  priceDollars: 6.75,
  description: "For anyone who has ever rearranged their tiles and suddenly felt like a genius, these socks are ideal for folks that love Mahjong so much, they only need the first four letters to get excited. 🕺\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance.\n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:36:28.308Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
